import { OnInit, OnDestroy, Component } from '@angular/core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { ActivatedRoute } from '@angular/router';

declare let dojoApp: any;

@Component({
    selector: 'dojo-billsuite-sessionmgmt',
    templateUrl: './dojo-billsuite-sessionmgmt.component.html'
})
export class DojoBillSuiteSessionMgmtComponent implements OnInit, OnDestroy {
    queryParams: any = {};
    constructor(private nxiRestService: NxiRestService,
                private router: ActivatedRoute) {
    }

    ngOnInit() {
       console.log('ngOnInit Bill Suite Session Management init');
       this.router.queryParams.subscribe(params => {
            if (params.pageAction) {
                this.queryParams.pageAction = params.pageAction;
            }
            if (params.status)  {
                this.queryParams.callbackStatusCode = parseInt(params.status, 10);
            }
       });
       this.billSuiteSessionMgmt(this.queryParams);
    }

    ngOnDestroy(): void {
        console.log('ngOnDestroy Bill Suite session Management');
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyBillSuiteSessionMgmt();
        }
    }

    billSuiteSessionMgmt(billSuiteParams: any) {

        if (dojoApp) {
            dojoApp.renderBillSuiteSessionMgmt(billSuiteParams);
        }
    }
}
